import React from "react";
import i18n from "../../i18n";
import { ServiceStatus } from "../../constants/enums";
import genericMap from "../../assets/images/generic-map.jpg";

const MapStatusMessage = ({ status }) => {
  let message, subMessage;
  
  switch(status) {
    case ServiceStatus.UNASSIGNED:
      message = i18n.t("MapNotAvailable");
      subMessage = i18n.t("ServiceNotStarted");
      break;
      case ServiceStatus.ASSIGNED:
        message = i18n.t("MapNotAvailable");
        subMessage = i18n.t("ServiceNotStarted");
        break;
    case ServiceStatus.STARTED:
      message = i18n.t("MapNotAvailable");
      subMessage = i18n.t("ServiceInProgressNoMap");
      break;
    default:
      message = i18n.t("NoRouteDataAvailable");
      subMessage = i18n.t("CheckBackLater");
  }

  return (
    <div className="gpx-viewer-status-container" style={{ 
      backgroundImage: `url(${genericMap})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      position: 'relative'
    }}>
      <div className="status-overlay" style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div className="status-content text-center" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          padding: '2rem',
          borderRadius: '12px',
          maxWidth: '80%',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)'
        }}>
          <div className="status-icon mb-3">
            <i className="bx bx-map-alt bx-burst bx-lg" style={{ color: "#FF5F00" }} />
          </div>
          <h5 className="status-title mb-2" style={{ color: "#FF5F00" }}>
            {message}
          </h5>
          <p className="status-message mb-3" style={{ color: "#495057" }}>
            {subMessage}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MapStatusMessage;
